import HealthActionBar from "./HealthActionBar";
import AvatarMini from "components/commons/AvatarMini";
import AnonymousAvatarMini from "components/commons/AnonymousAvatarMini";
import { useTranslation } from "react-i18next";

const HealthRealtTimeCard = (
    {
        healthData,
        onAction = (userGuid, actionType) => { }
    }
) => {

    const [t] = useTranslation(["global"])
    const { user, hr, isOffBody, lastUpdate, minHr, maxHr } = healthData

    let veryHight = maxHr;
    let hight = maxHr-5;
    let low = minHr+5;
    let veryLow = minHr;

    function getDataOldOpacity() {
        var delta = (Date.now() - lastUpdate*1000)
        if (delta > 3600000 * 5) {
            return "opacity-0" // more than 5 hours
        } else if (delta > 3600000) {
            return "opacity-25" // more than 1 hour
        } else if (delta > 1200000) {
            return "opacity-50" // more than 20 minutes
        } else if (delta > 600000) {
            return "opacity-75" // more than 10 minutes
        } else return null
    }

    function getDataOldTimeStamp() {
        var delta = (Date.now() - lastUpdate*1000)
        if (delta > 3600000 * 5) {
            return t("time.more_than_n_ago", {duration:"5h"}) // more than 5 hours
        } else if (delta > 3600000) {
            return t("time.more_than_n_ago", {duration:"1h"}) // more than 1 hour
        } else if (delta > 1200000) {
            return t("time.more_than_n_ago", {duration:"20 m"}) // more than 20 minutes
        } else if (delta > 600000) {
            return t("time.more_than_n_ago", {duration:"10 m"}) // more than 10 minutes
        } else return <>{t("property.updated_at_time")} {new Date(lastUpdate*1000).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}</>
    }

    function getSafeRangeColor() {
        if (hr == null) {
            return "bg-dark bg-opacity-25";
        }
        if (hr >= low && hr <= hight) {
            return "bg-dark bg-opacity-0";
        } else if ((hr > hight && hr <= veryHight) || (hr < low && hr >= veryLow)) {
            return "bg-warning bg-opacity-25";
        } else {
            return "bg-danger bg-opacity-25";
        }
    }

    function getHeartIcon() {
        if (hr == null) {
            return;
        }
        if (hr >= low && hr <= hight) {
            return <i className="fa-solid fa-heart fa-fade text-danger"></i>;
        } else if ((hr > hight && hr <= veryHight) || (hr < low && hr >= veryLow)) {
            return <i className="fa-solid fa-heart-circle-exclamation fa-beat text-warning"></i>;
        } else {
            return <i className="fa-solid fa-heart-circle-exclamation fa-beat text-danger"></i>;
        }
    }

    return <div className={`col `}>
        <div className={`col card ${getSafeRangeColor()}   text-white h-100 d-flex flex-column`}>
            <div className={`card-body d-flex flex-column `}>
                <div className="row px-2">
                    {
                        user.guid.length > 1 ?
                            <AvatarMini displayName={user.displayName} guid={user.guid} destination="/dashboard/health/history" />
                            : <AnonymousAvatarMini />
                    }
                </div>
                <div className="row px-2">
                    <div className="col">
                        <HealthActionBar onAction={(actionType) => onAction(user.guid, actionType)} />
                    </div>
                    <div className={`col text-end mt-2 py-2 ${getDataOldOpacity()}`}>
                        {
                            isOffBody ?

                                <h5><i className="fa-solid fa-hand"></i> OffBody</h5>
                                : <span>
                                    <span className={`h3 font-bold p-1`}>
                                        {getHeartIcon()} {hr || "-- " }
                                    </span>
                                    <small className="text-muted">bpm</small>
                                </span>
                        }

                    </div>
                </div>
            </div>
            <div className={`card-footer text-end opacity-100`}>
                <small className="text-muted"> {getDataOldTimeStamp()}</small>
            </div>
        </div>
    </div>
}

export default HealthRealtTimeCard